import Justore from 'justore';
const privateStack = Symbol('stack');

export default class ZindexManager {

    static managers = new Map();

    constructor(startIndex = 2000, name) {
        if (ZindexManager.managers.has(name)) {
            throw new Error(`Manager ${name} already declared`);
        }
        this.name = name;
        this.startIndex = startIndex + 1;
        this[privateStack] = [];
        this.indexStore = new Justore({}, name);
        ZindexManager.managers.set(name, this);
    }

    getIndexByElement(element) {
        return this.indexStore.read(element) || this.startIndex;
    }

    _computedIndex(index) {
        return this.startIndex + index;
    }

    shiftElementToStackEnd(element) {
        let elementOriPos = this[privateStack].indexOf(element);
        if (elementOriPos === this[privateStack].length - 1) {
            // do noting
        } else {
            this[privateStack].push(this[privateStack].splice(elementOriPos, 1)[0]);
            this.updateIndexes();
        }
    }

    has(element) {
        return this[privateStack].indexOf(element) >= 0;
    }

    add(element) {
        if (element) {
            if (this.has(element)) {
                this.shiftElementToStackEnd(element);
            } else {
                let newLength = this[privateStack].push(element);
                this.indexStore.write(element, this._computedIndex(newLength - 1));
            }
        }
        return this[privateStack].length;
    }

    remove(element) {
        let index = this[privateStack].indexOf(element);
        if (index !== -1) {
            this[privateStack].splice(index, 1);
        }
        this.indexStore.delete(element);
        this.updateIndexes();
    }

    clear() {
        this[privateStack] = [];
        this.updateIndexes();
    }

    updateIndexes() {
        this.indexStore.batchWrite(this[privateStack], draft => {
            this[privateStack].forEach((element, index) => {
                draft[element] = this._computedIndex(index);
            });
        });
    }
}
